import React from 'react'

function BookTwoRelease() {
  return (
	<section className="upcoming-games-area pb-140">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="book-single-title mb-55">
                <h4>released <span>Books</span></h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="upcoming-game-item mb-40">
                <div className="upcoming-book-head">
                  <div className="uc-books-head-title">
                    <span>April 20, 2025</span>
                    <h4><a href="https://www.amazon.com/gp/product/1738510549" target="_blank" rel="noopener noreferrer">The Awakening (Paperback)</a></h4>
                  </div>
                  <div className="uc-book-price">
                    <h5>From £7.99</h5>
                  </div>
                </div>
                <p>Second book in the Oliver and the Time Machine series, paperback version</p>
                <div className="upcoming-game-thumb">
                  <img src="assets/img/book2-full-cover-new.jpg" alt="The Awakening paperback" />
                  <div className="upcoming-game-cart">
                    <a href="https://www.amazon.com/gp/product/1738510549" target="_blank" rel="noopener noreferrer" className="btn transparent-btn"><i className="fas fa-shopping-basket" />BUY Now</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="upcoming-game-item mb-40">
                <div className="upcoming-book-head">
                  <div className="uc-books-head-title">
                    <span>Release date: May 03, 2025</span>
                    <h4><a href="https://www.amazon.com/gp/product/B0F7FG58J7" target="_blank" rel="noopener noreferrer" >The Awakening (e-book)</a></h4>
                  </div>
                  <div className="uc-book-price">
                    <h5>From £1.99</h5>
                  </div>
                </div>
                <p>Second book in the Oliver and the Time Machine series, Kindle, E-book version</p>
                <div className="upcoming-game-thumb">
                  <img src="assets/img/book2-full-cover-new.jpg" alt="The Awakening Kindle" />
                  <div className="upcoming-game-cart">
                    <a href="https://www.amazon.com/gp/product/B0F7FG58J7" target="_blank" rel="noopener noreferrer" className="btn transparent-btn"><i className="fas fa-shopping-basket" />BUY Now</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default BookTwoRelease